export enum AuditType 
{
    OperatorConnectedBySignalR = 1,
    OperatorDisconnectedBySignalR,

    OperatorWentOnline,
    OperatorWentPause,
    OperatorWentOffline,

    CreateSetting,
    UpdateSetting,
    RemoveSetting,

    CreateChannel,
    UpdateChannel,
    RemoveChannel,

    CreateOperator,
    UpdateOperator,
    RemoveOperator,

    OperatorWentPause1 = 401,
    OperatorWentPause2 = 402,
    OperatorWentPause3 = 403,
    OperatorWentPause4 = 404,
    OperatorWentPause5 = 405,
    OperatorWentPause6 = 406,
    OperatorWentPause7 = 407,
    OperatorWentPause8 = 408,
    OperatorWentPause9 = 409,
    OperatorWentPause10 = 410,
}